import { createRpcClientV2 } from 'rpc-client-utils';
import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import { defaultTo } from 'hub-http/middlewares/core';
import hubapiStack from 'hub-http/stacks/hubapi';
export const httpClient = promiseClient(createStack(defaultTo('timeout', 45000), hubapiStack));
export const rpcClient = createRpcClientV2({
  hubHttpClient: httpClient
});